import Phaser from 'phaser';

export default class MainMenu extends Phaser.Scene {
  constructor() {
    super({ key: 'MainMenu' });
  }

  preload(): void {
    this.load.bitmapFont('thick_8x8', 'thick_8x8.png', 'thick_8x8.xml');
    this.load.audio('bgMusic', 'music.mp3');
  }

  create(): void {
    const { width, height } = this.scale;

    const music = this.sound.add('bgMusic', {
      loop: true,
      volume: 0.25
    });

    music.play()

    this.add.bitmapText(width / 2, height / 4, 'thick_8x8', 'Loop Dungeon', 20)
        .setOrigin(0.5);

    const buttonWidth = 180;
    const buttonHeight = 30;
    const buttonX = width / 2;
    const buttonY = height / 2;

    const buttonBackground = this.add.rectangle(
        buttonX,
        buttonY,
        buttonWidth,
        buttonHeight,
        0x333333
    ).setInteractive();

    const buttonBorder = this.add.rectangle(
        buttonX,
        buttonY,
        buttonWidth,
        buttonHeight
    ).setStrokeStyle(2, 0xffffff);

    const startButton = this.add.bitmapText(
        buttonX,
        buttonY + 4,
        'thick_8x8',
        'Start Game',
        20
    ).setOrigin(0.5);

    const checkboxX = width / 2 - 50;
    const checkboxY = height / 2 + 60;

    const checkbox = this.add.rectangle(
        checkboxX,
        checkboxY,
        11,
        11,
        0x333333
    ).setInteractive();

    const checkboxBorder = this.add.rectangle(
        checkboxX,
        checkboxY,
        11,
        11
    ).setStrokeStyle(1, 0xffffff);

    const checkboxLabel = this.add.bitmapText(
        checkboxX + 12,
        checkboxY + 3,
        'thick_8x8',
        'CRT effect',
        12
    ).setOrigin(0, 0.5);

    const checkmark = this.add.bitmapText(
        checkboxX + 1,
        checkboxY + 3,
        'thick_8x8',
        'X',
        12
    ).setOrigin(0.5);

    const isCRTEnabled = localStorage.getItem('crtEffect') !== 'false';
    checkmark.setVisible(isCRTEnabled);

    buttonBackground.on('pointerover', () => {
      buttonBackground.setFillStyle(0x666666);
      startButton.setTint(0xffff00);
    });

    buttonBackground.on('pointerout', () => {
      buttonBackground.setFillStyle(0x333333);
      startButton.setTint(0xffffff);
    });

    buttonBackground.on('pointerdown', () => {
      this.scene.start('GameScene');
    });

    checkbox.on('pointerover', () => {
      checkbox.setFillStyle(0x666666);
    });

    checkbox.on('pointerout', () => {
      checkbox.setFillStyle(0x333333);
    });

    checkbox.on('pointerdown', () => {
      const newState = !checkmark.visible;
      checkmark.setVisible(newState);
      localStorage.setItem('crtEffect', newState.toString());

      if (newState) {
        this.cameras.main.setPostPipeline('CRT');
      } else {
        this.cameras.main.resetPostPipeline();
      }
    });

    checkboxLabel.setInteractive();
    checkboxLabel.on('pointerdown', () => {
      const newState = !checkmark.visible;
      checkmark.setVisible(newState);
      localStorage.setItem('crtEffect', newState.toString());

      if (newState) {
        this.cameras.main.setPostPipeline('CRT');
      } else {
        this.cameras.main.resetPostPipeline();
      }
    });

    if (isCRTEnabled) {
      this.cameras.main.setPostPipeline('CRT');
    } else {
      this.cameras.main.resetPostPipeline();
    }
  }
}
